export enum ConferenceStatus {
  Invited = 'invited',
  InConference = 'in_conference',
  OutOfConference = 'out_of_conference',
}
